import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import * as epdmCalculator from "../epdmCalculator";

type Props = {
    rectangularAmountEPDM: number;
    extraAmountEPDM: number;
    roofShape: epdmCalculator.RoofShape;
    shoppingList: epdmCalculator.EPDMShoppingList;
    mailParams: any;
    isolationRequired: boolean;
};

const Result = ({
    rectangularAmountEPDM,
    extraAmountEPDM,
    roofShape,
    mailParams,
    shoppingList,
    isolationRequired
}: Props) => {
    const { t } = useGranite();

    const {
        flexifoilBordersGlue,
        flexifoilSurfaceGlue,
        isolationAmount,
        epdmInfo,
        flexifoilBordersGlueProduct,
        flexifoilSurfaceGlueProduct,
        isolationProduct,
        flexifoilOverlapGlueProduct
    } = shoppingList;

    return (
        <div id="result">
            <ResultTitle mailParams={mailParams} />
            <Row>
                {roofShape === epdmCalculator.RoofShape.L_SHAPED ? (
                    <>
                        <ResultField
                            sm={12}
                            md={8}
                            lg={6}
                            copy={t(
                                "calculator.epdmCalculator.part1AmountEPDM"
                            )}
                            unit={"m"}
                            sup={2}
                            value={Number(
                                rectangularAmountEPDM / 10_000
                            ).toFixed(3)}
                        />
                        <ResultField
                            sm={12}
                            md={8}
                            lg={6}
                            copy={t(
                                "calculator.epdmCalculator.part2AmountEPDM"
                            )}
                            unit={"m"}
                            sup={2}
                            value={Number(extraAmountEPDM / 10_000).toFixed(3)}
                        />
                    </>
                ) : (
                    <ResultField
                        sm={12}
                        md={8}
                        lg={6}
                        copy={t(
                            "calculator.epdmCalculator.rectangularAmountEPDM"
                        )}
                        unit={"m"}
                        sup={2}
                        value={Number(rectangularAmountEPDM / 10_000).toFixed(
                            3
                        )}
                    />
                )}
            </Row>
            <Row>
                <Col>
                    <h4 className="d-sm-block">
                        {t("calculator.shoppinglist")}
                    </h4>
                </Col>
            </Row>
            {epdmInfo.map((info) => (
                <>
                    {info.product && (
                        <Row className={"calculator-group"}>
                            <ResultField
                                sm={6}
                                copy={info.product?.title}
                                value={Math.ceil(info.amount).toFixed(0)}
                            />
                        </Row>
                    )}
                </>
            ))}
            {flexifoilSurfaceGlueProduct && (
                <Row className={"calculator-group"}>
                    <ResultField
                        sm={6}
                        copy={flexifoilSurfaceGlueProduct.title}
                        value={Math.ceil(flexifoilSurfaceGlue).toFixed(0)}
                    />
                </Row>
            )}
            {flexifoilBordersGlueProduct && (
                <Row className={"calculator-group"}>
                    <ResultField
                        sm={6}
                        copy={flexifoilBordersGlueProduct.title}
                        value={Math.ceil(flexifoilBordersGlue).toFixed(0)}
                    />
                </Row>
            )}
            {flexifoilOverlapGlueProduct && (
                <Row className={"calculator-group"}>
                    <ResultField
                        sm={6}
                        copy={flexifoilOverlapGlueProduct.title}
                        value={1}
                    />
                </Row>
            )}
            {isolationRequired &&
                isolationProduct &&
                Math.ceil(isolationAmount) > 0 && (
                    <Row className={"calculator-group"}>
                        <ResultField
                            sm={6}
                            copy={isolationProduct.title}
                            value={Math.ceil(isolationAmount).toFixed(0)}
                        />
                    </Row>
                )}
        </div>
    );
};

export default Result;
